import { render, staticRenderFns } from "./details-ui.vue?vue&type=template&id=750596ca&scoped=true&"
import script from "./details-ui.vue?vue&type=script&lang=js&"
export * from "./details-ui.vue?vue&type=script&lang=js&"
import style0 from "./details-ui.vue?vue&type=style&index=0&id=750596ca&scoped=true&lang=scss&"
import style1 from "./details-ui.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750596ca",
  null
  
)

export default component.exports